import { useEffect, useState } from "react";
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField, ThemeProvider, Typography, createTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import AuthGuard from "../../components/AuthGuard";
import { useCookies } from "react-cookie";
import swal from "sweetalert";
import { jwtDecode } from "jwt-decode";


let theme = createTheme({
  palette: {
    primary: {
      main: '#0052cc',
    },
    secondary: {
      main: '#1A8D90',
    },
  },
});

const Form = ({callBackAfterSubmit}) => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [cookie,setCookie] = useCookies(['token','WSO2'])
  const [account,setAccountNumber] = useState("")
  const [btnDisabled,setBtnDisabled] = useState(true)
  const [selectedCompany,setSelectedCompany] = useState("")
  const [companyList,setCompanyList] = useState([])
  const [companyName,setCompanyName] = useState("")
  const decoded = jwtDecode(cookie["token"])
  const jsonDataParsed = JSON.parse(decoded.userInfo)

  useEffect(()=>{
    const fetchCompanies = async()=>{
      const data = await fetch(process.env.REACT_APP_BACKEND_URL+"/company/all",{headers:{
        Authorization:"Bearer "+cookie['token']
      }})
      if(data.status!==200){
        setCookie("token",null)
        return
      }
      const json = await data.json()
      setCompanyList(()=>{
        return json.map(usr=>({...usr}))
      })
    }
    fetchCompanies()
  },[])


  const handleFormSubmit = (e) => {
    e.preventDefault()
    if(btnDisabled){
      swal("Error","Please Enter a Valid Account Number","error")
      return
    }
    if(selectedCompany===""){
      swal("Error","Please Choose Company","error")
      return
    }
    fetch(process.env.REACT_APP_BACKEND_URL+"/account/add",{method:"POST",headers:{
      Authorization:"Bearer "+cookie['token'],
      'Content-Type':"application/json"
    },body:JSON.stringify({"account_number":account,"company":{id:selectedCompany}}),}).then(async(resp)=>{
     
      if(resp.status===200){
        callBackAfterSubmit()
      }
      else{
        swal("Error","This Account Number is Used","error")
      }
    }).catch(()=>{
      setCookie("token",null)
    })
  };

  const fetchAccountDetail = async(accountNumber)=>{
      const data = await fetch(process.env.REACT_APP_BACKEND_URL+"/account/accountDetail/"+accountNumber,{headers:{
        "Authorization":"Bearer "+cookie['token']
      }})
      if(data.status!==200){
        setCookie("token",null)
        return
      }
      const json = await data.json()
      if(json!=null&&json['MSGSTAT']==="SUCCESS"){
        setCompanyName(prev=>json['customer_name'])
        setBtnDisabled(prev=>false)
      }
  }

  const handleChange = (e)=>{
    if(e.target.value.length===13){
      fetchAccountDetail(e.target.value)
    }
    else{
      setBtnDisabled(true)
    }
    setAccountNumber(e.target.value)
  }

  const handleCompanyChange = (e)=>{
    setSelectedCompany(e.target.value)
  }
  return (
    <AuthGuard>
    <Box m="20px" mt={"5rem"} sx={{background:"white",width: "90%",
          maxWidth: "800px",boxSizing:"border-box",px:"1rem",zIndex:999,margin:"0 auto",borderRadius:"15px"}}>
    <Header title="Add Account" subtitle={"Add Company Account Number"} />
    <ThemeProvider theme={theme}>
    <form onSubmit={handleFormSubmit}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                  pt:"3rem"
                }}
              >
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Account Number"
                  onChange={handleChange}
                  value={account}
                  name="name"
                  sx={{ gridColumn: "span 2" }}
                />
                <Typography display={!btnDisabled?"block":"none"} color={"black"}>
                  {companyName}
                </Typography>
                <FormControl sx={{ gridColumn: "span 4" }}>
                  <InputLabel>Company</InputLabel>
                  <Select value={selectedCompany} label="Company" onChange={handleCompanyChange} sx={{ gridColumn: "span 4" }}>
                  {jsonDataParsed.roles.name!=="Company Admin"?(
                      companyList.map((item)=><MenuItem value={item.id}>{item.name}</MenuItem>)):(
                        companyList.filter(
                          (item) =>
                            item.id &&
                            jsonDataParsed.companies &&
                            item.id === jsonDataParsed.companies.id
                        )
                        .map((filteredItem) => (
                          <MenuItem
                            key={filteredItem.id}
                            value={filteredItem.id}
                          >
                            {filteredItem.name}
                          </MenuItem>
                        ))

                      )}
                  </Select>
                </FormControl>
              </Box>
              <Box display="flex" justifyContent="end" mt="20px">
                <Button type="submit" color="secondary" variant="contained" disabled={btnDisabled||selectedCompany===""}>
                  Add Account
                </Button>
              </Box>
            </form>
</ThemeProvider>
          </Box>
    </AuthGuard>
  );
};

export default Form;
